var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.787c-6.58 0-9.343 5.936-9.343 6.06 0 .123 2.763 6.06 9.343 6.06s9.343-5.937 9.343-6.06c0-.124-2.763-6.06-9.343-6.06zM3.408 7.235L.96 4.778M8.069 4.217L7.071.977M18.592 7.235l2.449-2.457M13.931 4.217l.998-3.24",
    stroke: "#000",
    strokeWidth: 0.833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.338 9.235a2.748 2.748 0 00.348 2.068 2.723 2.723 0 003.765.865 2.748 2.748 0 00.862-3.777 2.724 2.724 0 00-3.765-.865 2.74 2.74 0 00-1.21 1.71z",
    stroke: "#000",
    strokeWidth: 0.833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgEnabled;